import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import TeeTimesComponent from './js/tee-times.component';
import TeeTimesList from './js/tee-times-list';

ComponentsFactory.getInstance().define('tee-times', TeeTimesComponent);

export {
    TeeTimesList,
};
